<script>
/*
* This component is size-customizable so to specify the component height/width you have to
* bind the class where you've specified the component size to the component the following way:
*
* <ActionButton :class="'your-class-name'"/>
* */
export default {
  props: {
    action: {
      type: Function,
      required: false
    },
    caption: {
      type: String,
      required: true,
    }
  },
  methods: {
    noop() {

    }
  }
}
</script>

<template>
  <button class="action-button" @click="action ? action() : noop()">{{ caption }}</button>
</template>

<style lang="scss" scoped>
@import '@design';

.action-button {
  cursor: pointer;
  color: $white;
  line-height: 35px;
  font-family: "Open Sans Semibold",sans-serif;
  font-weight: 600;
  font-size: 15px;
  background: $orange;
  border: 1px solid $orange;
  box-sizing: border-box;
  border-radius: 5px;
  text-align: center;
  text-transform: uppercase;
}

.action-button:hover {
  background: $hover-orange;
  border: 1px solid $hover-orange;
}
</style>
